import { Text } from '../../../../../../components/atoms/text/text';
import { Answers, Survey } from '../../../../survey-types';
import { getQuestionData } from '../../../../utils/surveys/questions';

import { ReadMoreLink } from './read-more-link';

interface IQuestionItemProps {
  readonly detailed: string;
  readonly index: number;
  readonly questionItem: { question: string };
  readonly answers: Answers;
  readonly survey: Survey;
  readonly truncateTo: number;
  readonly link?: string;
  readonly externalLink?: string;
}

const EXTERNAL_LINK_TYPE = 'external';

export const QuestionItem = ({
  questionItem,
  index,
  detailed,
  answers,
  survey,
  truncateTo,
  link,
  externalLink,
}: IQuestionItemProps) => {
  const { answer, formattedAnswer, questionName, questionObj, wasTruncated } = getQuestionData({
    answers,
    questionItem,
    survey,
    truncateTo,
  });

  const questionNumber = index + 1;
  const linkTo = link === EXTERNAL_LINK_TYPE ? externalLink : link;

  return (
    <div className="self-stretch flex flex-col justify-start items-start gap-1" key={`${questionName}-${index}`}>
      {detailed === 'true' && (
        <div className="self-stretch inline-flex justify-start items-start gap-1">
          <div className="justify-start text-slate-800 text-base font-normal">{questionNumber}.</div>
          <div className="flex-1 justify-start text-slate-800 text-base font-normal">
            {questionObj?.title ?? questionName}
          </div>
        </div>
      )}
      <Text className="free-text-active">
        {' '}
        {`"${formattedAnswer}"`}
        <ReadMoreLink answer={answer ?? ''} linkTo={linkTo} wasTruncated={wasTruncated} />
      </Text>
    </div>
  );
};
